import { Box, Button, Typography } from "drift-ui";
import { Component, type ErrorInfo, type ReactNode } from "react";

interface ForthLeafErrorBoundaryProps {
  children: ReactNode;
}

interface ForthLeafErrorBoundaryState {
  hasError: boolean;
}

export class ForthLeafErrorBoundary extends Component<
  ForthLeafErrorBoundaryProps,
  ForthLeafErrorBoundaryState
> {
  state: ForthLeafErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ForthLeafErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Forth Leaf encountered an unexpected error.", error, info);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          height: "100vh",
          justifyContent: "center",
        }}
      >
        <Typography component="h1" variant="h5">
          Something went wrong in Forth Leaf.
        </Typography>
        <Typography>Reload the page to try again.</Typography>
        <Button onClick={() => window.location.reload()}>Reload</Button>
      </Box>
    );
  }
}
